import script from "./recovery.vue?vue&type=script&setup=true&lang=js"
export * from "./recovery.vue?vue&type=script&setup=true&lang=js"

import "./recovery.vue?vue&type=style&index=0&id=73e5c024&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4e85b6a685c6792d169835830baf5532/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e5c024"]])

export default __exports__